import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  sideToolbar: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    width: '40px',
    backgroundColor: '#FFFFFF',
    paddingTop: '15px',
    zIndex: 20,
    transition: '0.5s ease-in-out',   
  },
  sideToolbarNonFullscreen: {
    borderTop: 'solid 1px rgba(44, 45, 62, 0.3)',
  },
  sideToolbarFullscreen: {
    top: '48px',
    left: '0px',
    borderRight: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderTop: 'solid 1px rgba(44, 45, 62, 0.3)',
    height: '100%',
  },
  sideToolbarIcon: {
    width: '16px',
    height: '16px',
    cursor: 'pointer',
    marginBottom: '6px',
    padding: '12px',
    borderRadius: '50%',
    '&:hover, &:focus-visible': {
      backgroundColor: 'rgba(202, 202, 252, 0.3)',
      outline: 'none',
    },
  },
  arrowToolbarIcon: {
    position: 'absolute',
    left: '19px',
    width: '16px',
    height: '16px',
    margin: '12px',
    cursor: 'pointer',
  },
  disabledAction: {
    position:'absolute',
    top: '-7px', 
    left: '-5px', 
    height:'66%',
    width:'66%',
  },
  relativeWrapper: {
    position: 'relative',
  },
  arrowToolbarIconTop: {
    top: '2px',
  },
  arrowToolbarIconBottom: {
    top: '49px',
  },
}));
